import { useNavigate } from "react-router-dom";

interface MentionParserProps {
  text: string;
  className?: string;
}

export function MentionParser({ text, className = "" }: MentionParserProps) {
  const navigate = useNavigate();

  const parseText = (text: string) => {
    // Split by @mentions but keep the @username
    const parts = text.split(/(@[\w-]+)/g);
    
    return parts.map((part, index) => {
      if (part.startsWith('@')) {
        const username = part.slice(1);
        return (
          <span
            key={index}
            onClick={(e) => {
              e.stopPropagation();
              navigate(`/user/${username}`);
            }}
            className="text-primary font-medium cursor-pointer hover:underline"
          >
            {part}
          </span>
        );
      }
      return <span key={index}>{part}</span>;
    });
  };

  return <span className={className}>{parseText(text)}</span>;
}

